import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useState } from "react";
import Dropzone from "react-dropzone";
import _ from "lodash";
import FileDisplay from "./components/FileDisplay";
import { Spinner } from "react-bootstrap";

function ReactDropZoneWidget(props) {
  var isReading = props.isReading,
      onAcceptedFiles = props.onAcceptedFiles,
      onChange = props.onChange;

  var _useState = useState(false),
      saving = _useState[0],
      setSaving = _useState[1];

  var acceptedFiles = _.get(props, "options.accepted");

  var originalValue = _.isArray(props.value) ? props.value : [];

  var _onDrop = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(acceptedFiles) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setSaving(true);

              if (!(acceptedFiles.length > 0 && onAcceptedFiles)) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return onAcceptedFiles([].concat(originalValue, acceptedFiles));

            case 5:
              if (!(acceptedFiles.length > 0 && onChange)) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return onChange([].concat(originalValue, acceptedFiles));

            case 8:
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              alert(_context.t0);

            case 13:
              _context.prev = 13;
              setSaving(false);
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10, 13, 16]]);
    }));

    return function _onDrop(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleRemove = function handleRemove(item, index) {
    var filteredFiles = _.reject(props.value, function (file, currentIndex) {
      return index === currentIndex;
    });

    props.onChange && props.onChange(filteredFiles);
  };

  var areFilesVisible = _.get(props, "options.withFileDisplay") && !_.isEmpty(props.value);
  return /*#__PURE__*/React.createElement(Dropzone, {
    onDrop: _onDrop,
    accept: acceptedFiles || ["image/*"],
    disabled: saving
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
        getInputProps = _ref2.getInputProps,
        isDragActive = _ref2.isDragActive;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
      className: "d-print-none"
    }, /*#__PURE__*/React.createElement("div", _extends({
      className: "dropzone " + (isDragActive ? "active" : "")
    }, getRootProps()), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), {
      name: props.id
    })), saving ? /*#__PURE__*/React.createElement("div", {
      className: "m-auto"
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: "sm"
    }), /*#__PURE__*/React.createElement("span", null, "Handling files... \xA0"), /*#__PURE__*/React.createElement("span", {
      className: "spinner-border spinner-border-sm text-info",
      role: "status",
      "aria-hidden": "true"
    })) : isDragActive ? /*#__PURE__*/React.createElement("p", null, "Drop here...") : /*#__PURE__*/React.createElement("p", null, "Drag and drop files here, or click to select files"))), props.rawErrors && props.rawErrors.map(function (error) {
      return /*#__PURE__*/React.createElement("div", null, error);
    }), areFilesVisible && /*#__PURE__*/React.createElement(FileDisplay, {
      files: props.value,
      onRemove: handleRemove
    }));
  });
}

export default ReactDropZoneWidget;